import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    clienteId: 0,
    cliente: null,
    clienteNombre: null,
    periodo: new Date(1900, 1, 1),
    montoVentas: 0,
    montoPresupuestos: 0,
    saldo: 0,
    condiciones: [],
    presupuestosInternos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, params) {
        if (params) {
            state.cliente = params.cliente || null;
            if (params.cliente) {
                state.clienteId = params.cliente.id ? params.cliente.id : 0;
                state.clienteNombre = params.cliente.nombre ? params.cliente.nombre.trim() : null;
            } else {
                state.clienteId = 0;
                state.clienteNombre = null;
            }
            state.periodo = params.periodo || new Date(1900, 1, 1);
        } else {
            state.clienteId = 0;
            state.cliente = null;
            state.clienteNombre = null;
            state.periodo = new Date(1900, 1, 1);
        }
        state.montoVentas = 0;
        state.montoPresupuestos = 0;
        state.saldo = 0;
        state.condiciones = [];
        state.presupuestosInternos = [];
    },
    'SET_REBATE' (state, clienteRebate) {
        state.condiciones = clienteRebate.condiciones.sort((a, b) => a.montoMinimo - b.montoMinimo );
        state.montoVentas = parseFloat(clienteRebate.montoVentas);
        state.montoPresupuestos = parseFloat(clienteRebate.montoPresupuestos);
        state.saldo = parseFloat(clienteRebate.saldo);
        state.presupuestosInternos = clienteRebate.presupuestosInternos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit } ) {
        commit('INICIALIZAR');
    },
    getClienteRebate ( { commit, state }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);

            let getRebate = false;
            if (state.cliente) {
                if (state.cliente.id != 0) {
                    getRebate = true;
                }
            }

            if (getRebate) {
                apiAxios.get('clientes/' + state.cliente.id + '/rebate/' + state.periodo.getFullYear().toString())
                    .then(res => {
                        commit('SET_REBATE', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }

        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}